<template>
  <section class="error-404">
    <div class="error-404__content">
      <h1 class="error-404__header heading heading--md">
        We can't seem to find the page you're looking for.
      </h1>
      <p class="error-404__text">
        You can go back to our
        <router-link :to="{ name: HOME_PAGE_NAME }">homepage</router-link> or
        visit our
        <router-link :to="{ name: FAQ_PAGE_NAME }">FAQ page</router-link>
      </p>
    </div>
  </section>
</template>

<script>
import { HOME_PAGE_NAME, FAQ_PAGE_NAME } from "../../router/names";

export default {
  data() {
    return {
      HOME_PAGE_NAME,
      FAQ_PAGE_NAME
    };
  },
  metaInfo: {
    title: "404 Not Found"
  }
};
</script>
